"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _createPublicI18nProvider = _interopRequireDefault(require("I18n/init/providers/createPublicI18nProvider"));

var _publicTracker = _interopRequireDefault(require("../lib/usage/publicTracker"));

var _App = _interopRequireDefault(require("../App"));

var i18nProvider = (0, _createPublicI18nProvider.default)();
new _App.default({
  i18nProvider: i18nProvider,
  tracker: _publicTracker.default
}).start(false);